/**
 * react-simple-keyboard CSS — Yodi African keyboard.
 * Responsive buttons that adapt to container width.
 */
export const KEYBOARD_THEME_CSS = `
  .yodi-kb-theme.hg-theme-default.simple-keyboard {
    background: transparent !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    font-family: inherit !important;
  }
  .yodi-kb-theme .hg-row {
    display: flex !important;
    justify-content: center !important;
    gap: 3px !important;
    margin: 3px 0 !important;
    flex-wrap: nowrap !important;
  }
  .yodi-kb-theme .hg-button {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex: 1 1 0 !important;
    height: clamp(32px, 4vw, 44px) !important;
    min-width: 0 !important;
    padding: 0 clamp(3px, 0.5vw, 8px) !important;
    margin: 0 !important;
    border-radius: 8px !important;
    font-size: clamp(0.65rem, 1.1vw, 0.95rem) !important;
    font-weight: 500 !important;
    line-height: 1 !important;
    cursor: pointer !important;
    user-select: none !important;
    transition: all 0.15s ease !important;
    background: rgba(255,255,255,0.04) !important;
    color: rgba(255,255,255,0.75) !important;
    border: 1px solid rgba(255,255,255,0.06) !important;
    box-shadow: 0 1px 2px rgba(0,0,0,0.15) !important;
    overflow: visible !important;
    white-space: nowrap !important;
  }
  .yodi-kb-theme .hg-button:hover {
    background: rgba(255,255,255,0.08) !important;
    color: rgba(255,255,255,0.95) !important;
    border-color: rgba(255,255,255,0.12) !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.25) !important;
  }
  .yodi-kb-theme .hg-button:active {
    transform: translateY(0) scale(0.97);
    background: rgba(249,115,22,0.12) !important;
    border-color: rgba(249,115,22,0.2) !important;
    color: rgba(249,115,22,0.9) !important;
  }
  .yodi-kb-theme .hg-button.hg-functionBtn {
    background: rgba(249,115,22,0.06) !important;
    color: rgba(249,115,22,0.8) !important;
    border-color: rgba(249,115,22,0.15) !important;
    font-weight: 600 !important;
  }
  .yodi-kb-theme .hg-button.hg-functionBtn:hover {
    background: rgba(249,115,22,0.12) !important;
    color: rgba(249,115,22,1) !important;
  }
  .yodi-kb-theme .hg-button[data-skbtn="{shift}"] {
    flex: 1.15 0 0 !important;
    background: rgba(255,255,255,0.025) !important;
    color: rgba(255,255,255,0.48) !important;
    border-color: rgba(255,255,255,0.07) !important;
    font-size: clamp(0.75rem, 1.2vw, 1rem) !important;
  }
  .yodi-kb-theme .hg-button[data-skbtn="{shift}"].yodi-shift-active {
    background: rgba(249,115,22,0.10) !important;
    color: rgba(253,186,116,0.95) !important;
    border-color: rgba(253,186,116,0.22) !important;
  }
  .yodi-kb-theme .hg-button[data-skbtn="{shift}"]:hover {
    background: rgba(255,255,255,0.06) !important;
    color: rgba(255,255,255,0.74) !important;
  }
  .yodi-kb-theme .hg-button[data-skbtn="{shift}"].yodi-shift-active:hover {
    background: rgba(249,115,22,0.13) !important;
    color: rgba(253,186,116,1) !important;
  }
  .yodi-kb-theme .hg-button[data-skbtn="{bksp}"] {
    flex: 1.5 0 0 !important;
  }
  .yodi-kb-theme .hg-button[data-skbtn="{space}"] {
    flex: 4 1 0 !important;
  }

  /* Visual indicator for buttons with long-press variants */
  .yodi-kb-theme .hg-button.has-variants::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 4px;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: rgba(249,115,22,0.5);
    pointer-events: none;
  }

  .yodi-kb-theme .hg-button.has-variants:hover::after {
    background: rgba(249,115,22,0.8);
    box-shadow: 0 0 4px rgba(249,115,22,0.6);
  }

  /* Responsive adjustments */
  @media (max-width: 640px) {
    .yodi-kb-theme .hg-button {
      height: clamp(28px, 5vw, 38px) !important;
      font-size: clamp(0.55rem, 1.3vw, 0.85rem) !important;
    }
  }

  @media (min-width: 1024px) {
    .yodi-kb-theme .hg-button {
      height: clamp(38px, 3.5vw, 48px) !important;
      font-size: clamp(0.75rem, 1vw, 1rem) !important;
    }
  }
`;

